export default __webpack_public_path__ + "static/media/info.1150e0c1.svg";